export default (function (_ref) {
  var request = _ref.request;
  return {
    planAdd: function planAdd(data) {
      return request({
        url: '/grow/plan/add',
        method: 'post',
        data: data
      });
    },
    planModify: function planModify(data) {
      return request({
        url: "/grow/plan/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    planDel: function planDel(id) {
      return request({
        url: "/grow/plan/".concat(id, "/del"),
        method: 'delete'
      });
    },
    planHandle: function planHandle(handleId, data) {
      return request({
        url: "/grow/plan/".concat(handleId, "/handle"),
        method: 'post',
        data: data
      });
    },
    planQuery: function planQuery(data) {
      return request({
        url: '/grow/plan/query',
        method: 'get',
        params: data
      });
    },
    planDetail: function planDetail(id) {
      return request({
        url: "/grow/plan/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});